<template>
    <el-card>
        <div slot="header">
            <span style="font-size: 18px; font-weight: bold">产品配置</span>
        </div>
        <div class="product-config-container">
            <!-- 左侧配置分组列表 -->
            <div class="config-group-list">
                <div class="list-title">
                    <span>配置分组</span>
                    <el-button type="primary" size="mini" @click="handleAddGroup">新增配置分组</el-button>
                </div>
                <el-empty v-if="groupList.length === 0 && !groupLoading" description="暂无配置分组" />
                <div v-else class="group-scroll" @scroll="handleGroupScroll">
                    <el-menu :default-active="activeGroup" class="group-menu" @select="handleGroupSelect" >
                        <el-menu-item v-for="group in groupList" :key="String(group.id)" :index="String(group.id)" >
                            <div class="group-item">
                                <span class="group-name">{{ group.name }}</span>
                                <div class="group-actions">
                                    <el-button class="group-action-btn" type="text" size="mini" icon="el-icon-edit" @click.stop="handleEditGroup(group)" />
                                    <el-button class="group-action-btn group-delete-btn" type="text" size="mini" icon="el-icon-delete" @click.stop="handleDeleteGroup(group)" />
                                </div>
                            </div>
                        </el-menu-item>
                    </el-menu>
                    <div class="load-more">
                        <span v-if="groupLoading">加载中...</span>
                        <span v-else-if="hasMoreGroups">上滑加载更多</span>
                        <span v-else-if="groupList.length">已加载全部 {{ groupTotal }} 个</span>
                    </div>
                </div>
            </div>

            <!-- 右侧子项分页表格 -->
            <div class="item-table-wrapper">
                <div class="table-header">
                    <div class="table-title">{{ tableTitle }}</div>
                    <el-button type="primary" size="mini" @click="handleAddItem">增加配置子项</el-button>
                </div>
                <el-empty v-if="!activeGroup" description="请先选择左侧配置分组" />
                <el-empty v-else-if="itemList.length === 0" description="暂无子项数据" />

                <el-table v-else :data="itemList" border stripe style="width: 100%" :fit="true">
                    <el-table-column prop="sortOrder" label="排序" align="center" min-width="80" fixed="left" show-overflow-tooltip />
                    <el-table-column prop="code" label="子项编码" align="center" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="name" label="子项名称" align="center" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="urlHttp" label="子项图片" align="center" min-width="100">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.urlHttp" fit="cover"
                                style="width: 50px; height: 50px; border-radius: 4px; cursor: pointer"
                                :src="scope.row.urlHttp"
                                :preview-src-list="[scope.row.urlHttp]" />
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="paramInner"  label="内部参数" align="center" min-width="140" show-overflow-tooltip />
                    <el-table-column prop="paramOut" label="外部参数" align="center" min-width="140" show-overflow-tooltip />
                    <el-table-column prop="priceInner" label="内部价格" align="center" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="priceOut" label="外部价格" align="center" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="unit" label="单位" align="center" min-width="80" show-overflow-tooltip />
                    <el-table-column prop="status" label="状态" align="center" min-width="80">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                                {{ scope.row.status === 1 ? '启用' : '禁用' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" min-width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEditItem(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDeleteItem(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    v-if="activeGroup && itemList.length > 0"
                    class="pagination"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="itemTotal"
                    @current-change="handlePageChange"
                    @size-change="handleSizeChange"
                />
            </div>
        </div>

        <!-- 新增/编辑配置分组弹窗 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="500px"
            :close-on-click-modal="false"
        >
            <el-form ref="form" :model="form" label-width="120px" :rules="formRules">
                <el-form-item label="配置分组编码" prop="code">
                    <el-input v-model="form.code" placeholder="请输入配置分组编码" />
                </el-form-item>
                <el-form-item label="配置分组名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入配置分组名称" />
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number v-model="form.sortOrder" :min="0" :max="9999" controls-position="right" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
                        <el-option label="禁用" :value="0" />
                        <el-option label="启用" :value="1" />
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 新增/编辑配置子项弹窗 -->
        <el-dialog
            :title="itemDialogTitle"
            :visible.sync="itemDialogVisible"
            width="600px"
            :close-on-click-modal="false"
            @closed="resetItemForm"
        >
            <el-form ref="itemFormRef" :model="itemForm" label-width="100px" :rules="itemFormRules">
                <el-form-item label="子项编码" prop="code">
                    <el-input v-model="itemForm.code" placeholder="请输入子项编码" maxlength="50" clearable />
                </el-form-item>
                <el-form-item label="子项名称" prop="name">
                    <el-input v-model="itemForm.name" placeholder="请输入子项名称" maxlength="50" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="子项图片" prop="urlHttp">
                    <el-upload
                        class="item-uploader"
                        action="#"
                        :show-file-list="false"
                        :http-request="handleItemUpload"
                        accept="image/*"
                    >
                        <el-image v-if="itemForm.urlHttp" :src="itemForm.urlHttp" fit="cover" class="item-uploader-image" />
                        <i v-else class="el-icon-plus item-uploader-icon" />
                    </el-upload>
                </el-form-item>
                <el-form-item label="内部参数" prop="paramInner">
                    <el-input v-model="itemForm.paramInner" type="textarea" :rows="2" placeholder="请输入内部参数" maxlength="200" show-word-limit />
                </el-form-item>
                <el-form-item label="外部参数" prop="paramOut">
                    <el-input v-model="itemForm.paramOut" type="textarea" :rows="2" placeholder="请输入外部参数" maxlength="200" show-word-limit />
                </el-form-item>
                <el-form-item label="内部价格(元)" prop="priceInner">
                    <el-input v-model="itemForm.priceInner" placeholder="请输入内部价格" />
                </el-form-item>
                <el-form-item label="外部价格(元)" prop="priceOut">
                    <el-input v-model="itemForm.priceOut" placeholder="请输入外部价格" />
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="itemForm.unit" placeholder="请输入单位，如 套" maxlength="20" clearable />
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number v-model="itemForm.sortOrder" :min="0" :max="9999" controls-position="right" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="itemForm.status" placeholder="请选择状态" style="width: 100%">
                        <el-option label="禁用" :value="0" />
                        <el-option label="启用" :value="1" />
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="itemDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="itemSubmitLoading" @click="handleItemSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import {
    configGroupList, configGroupAdd, configGroupUpdate, configGroupDelete,
    configItemList, configItemAdd, configItemDelete, configItemUpdate, configItemDetail,
    uploadFile
} from '@/api/quote'

export default {
    name: 'ConfigGroup',
    data() {
        return {
            activeGroup: '',
            currentPage: 0,
            pageSize: 20,
            dialogVisible: false,
            dialogTitle: '新增配置分组',
            isEdit: false,
            form: {
                id: null,
                code: '',
                name: '',
                sortOrder: 0,
                status: 1
            },
            formRules: {
                code: [{ required: true, message: '请输入配置分组编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入配置分组名称', trigger: 'blur' }]
            },
            itemDialogVisible: false,
            itemDialogTitle: '新增配置子项',
            itemIsEdit: false,
            itemSubmitLoading: false,
            itemForm: {
                id: null,
                code: '',
                name: '',
                urlHttp: '',
                uploadFile: null,
                paramInner: '',
                paramOut: '',
                priceInner: '',
                priceOut: '',
                unit: '',
                sortOrder: 0,
                status: 1
            },
            itemFormRules: {
                code: [{ required: true, message: '请输入子项编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入子项名称', trigger: 'blur' }],
                priceInner: [{ required: true, message: '请输入内部价格', trigger: 'blur' }],
                priceOut: [{ required: true, message: '请输入外部价格', trigger: 'blur' }]
            },
            groupList: [],
            groupPage: 1,
            groupPageSize: 20,
            groupTotal: 0,
            groupLoading: false,
            itemList: [],
            itemTotal: 0
        }
    },
    computed: {
        tableTitle() {
            if (!this.activeGroup) return '配置子项'
            const group = this.groupList.find(item => String(item.id) === this.activeGroup)
            return group ? `${group.name} - 配置子项` : '配置子项'
        },
        hasMoreGroups() {
            return this.groupList.length < this.groupTotal
        }
    },
    mounted() {
        this.getConfigGroupList()
    },
    methods: {
        // 获取配置分组列表（左侧菜单，滚动分页，append 时追加下一页）
        getConfigGroupList(append = false) {
            if (this.groupLoading) return
            this.groupLoading = true
            configGroupList({
                filter: [],
                sorted: [{ name: 'sortOrder', type: 'ASC' }],
                current: this.groupPage,
                size: this.groupPageSize
            }).then(res => {
                if (res && res.success && res.result) {
                    const records = res.result.records || []
                    this.groupList = append ? this.groupList.concat(records) : records
                    this.groupTotal = res.result.total || 0
                }
            }).catch(error => {
                console.error('获取配置分组列表失败：', error)
            }).finally(() => {
                this.groupLoading = false
            })
        },
        // 左侧列表滚动到底部时加载下一页
        handleGroupScroll(event) {
            const el = event.target
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
                this.loadMoreGroups()
            }
        },
        // 加载下一页（追加到列表尾部）
        loadMoreGroups() {
            if (this.groupLoading || !this.hasMoreGroups) return
            this.groupPage += 1
            this.getConfigGroupList(true)
        },
        // 处理配置分组选择
        handleGroupSelect(index) {
            this.activeGroup = index
            this.currentPage = this.currentPage
            this.itemList = []
            this.itemTotal = 0
            this.getConfigItemList()
        },
        // 获取配置子项列表
        getConfigItemList() {
            if (!this.activeGroup) return
            configItemList({
                filter: [
                    { name: 'groupId', value: Number(this.activeGroup), type: 'EQ' }
                ],
                sorted: [{ name: 'sortOrder', type: 'ASC' }],
                current: this.currentPage,
                size: this.pageSize
            }).then(res => {
                console.log('配置子项列表返回', res)
                if (res.success && res.result) {
                    this.itemList = res.result.records 
                    this.itemTotal = res.result.total 
                }
            })
        },
        // 处理分页变化
        handlePageChange(page) {
            if (this.currentPage !== page) {
                this.currentPage = page
                this.getConfigItemList()
            }
        },
        // 处理每页条数变化
        handleSizeChange(size) {
            this.pageSize = size
            this.currentPage = 1
            this.getConfigItemList()
        },
        // 重置子项表单
        resetItemForm() {
            this.itemForm = {
                id: null,
                code: '',
                name: '',
                urlHttp: '',
                uploadFile: null,
                paramInner: '',
                paramOut: '',
                priceInner: '',
                priceOut: '',
                unit: '',
                sortOrder: 0,
                status: 1
            }
            this.$refs.itemFormRef && this.$refs.itemFormRef.clearValidate()
        },
        // 打开新增子项弹窗
        handleAddItem() {
            if (!this.activeGroup) {
                this.$message.warning('请先选择左侧配置分组')
                return
            }
            this.itemIsEdit = false
            this.itemDialogTitle = '新增配置子项'
            this.resetItemForm()
            this.itemDialogVisible = true
        },
        // 打开编辑子项弹窗
        async handleEditItem(row) {
            this.itemIsEdit = true
            this.itemDialogTitle = '编辑配置子项'
            this.resetItemForm()
            this.itemDialogVisible = true
            try {
                const res = await configItemDetail(row.id)
                if (res && res.code === '0000') {
                    const data = res.result || {}
                    this.itemForm = {
                        id: data.id,
                        code: data.code,
                        name: data.name,
                        urlHttp: data.urlHttp,
                        uploadFile: null,
                        paramInner: data.paramInner,
                        paramOut: data.paramOut,
                        priceInner: data.priceInner,
                        priceOut: data.priceOut,
                        unit: data.unit,
                        sortOrder: data.sortOrder,
                        status: data.status
                    }
                } else {
                    this.$message.error(res.message || '获取子项详情失败')
                    this.itemDialogVisible = false
                }
            } catch (error) {
                console.error('获取配置子项详情失败：', error)
                this.$message.error('获取子项详情失败')
                this.itemDialogVisible = false
            }
        },
        // 上传子项图片
        async handleItemUpload({ file }) {
            const formData = new FormData()
            formData.append('file', file)
            try {
                const res = await uploadFile(formData, 'quote')
                if (res && res.code === '0000') {
                    this.itemForm.uploadFile = res.result
                    this.itemForm.urlHttp = res.result.urlHttp
                    this.$message.success('上传成功')
                } else {
                    this.$message.error(res.message || '上传失败')
                }
            } catch (error) {
                console.error('上传子项图片失败：', error)
                this.$message.error('上传失败')
            }
        },
        // 保存子项
        handleItemSubmit() {
            this.$refs.itemFormRef.validate(async valid => {
                if (!valid) return
                this.itemSubmitLoading = true
                try {
                    const param = {
                        id: this.itemForm.id,
                        groupId: Number(this.activeGroup),
                        code: this.itemForm.code,
                        name: this.itemForm.name,
                        urlHttp: this.itemForm.urlHttp,
                        paramInner: this.itemForm.paramInner,
                        paramOut: this.itemForm.paramOut,
                        priceInner: this.itemForm.priceInner,
                        priceOut: this.itemForm.priceOut,
                        unit: this.itemForm.unit,
                        sortOrder: this.itemForm.sortOrder,
                        status: this.itemForm.status
                    }
                    if (this.itemForm.uploadFile) {
                        param.uploadFile = this.itemForm.uploadFile
                    }

                    let res
                    if (this.itemIsEdit) {
                        param.id = this.itemForm.id
                        res = await configItemUpdate(param)
                    } else {
                        param.groupId = Number(this.activeGroup)
                        res = await configItemAdd(param)
                    }

                    if (res && res.code === '0000') {
                        this.$message.success(this.itemIsEdit ? '修改成功' : '添加成功')
                        this.itemDialogVisible = false
                        this.getConfigItemList()
                    } else {
                        this.$message.error(res.message || (this.itemIsEdit ? '修改失败' : '添加失败'))
                    }
                } catch (error) {
                    console.error('保存配置子项失败：', error)
                    this.$message.error('保存失败')
                } finally {
                    this.itemSubmitLoading = false
                }
            })
        },
        // 删除子项
        handleDeleteItem(row) {
            this.$confirm('确认删除该配置子项?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await configItemDelete(row.id)
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功')
                        if (this.itemList.length === 1 && this.currentPage > 1) {
                            this.currentPage -= 1
                        }
                        this.getConfigItemList()
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                } catch (error) {
                    console.error('删除配置子项失败：', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {})
        },
        // 重置分组表单
        resetGroupForm() {
            this.form = {
                id: null,
                code: '',
                name: '',
                sortOrder: 0,
                status: 1
            }
            this.$refs.form && this.$refs.form.clearValidate()
        },
        // 新增配置分组（打开弹窗）
        handleAddGroup() {
            this.isEdit = false
            this.dialogTitle = '新增配置分组'
            this.resetGroupForm()
            this.dialogVisible = true
        },
        // 编辑配置分组（打开弹窗）
        handleEditGroup(group) {
            this.isEdit = true
            this.dialogTitle = '编辑配置分组'
            this.form = {
                id: group.id,
                code: group.code,
                name: group.name,
                sortOrder: group.sortOrder,
                status: group.status
            }
            this.dialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate()
            })
        },
        // 保存配置分组
        handleSubmit() {
            this.$refs.form.validate(async valid => {
                if (!valid) return

                const groupData = {
                    code: this.form.code,
                    name: this.form.name,
                    sortOrder: this.form.sortOrder,
                    status: this.form.status
                }

                try {
                    let res
                    if (this.isEdit) {
                        groupData.id = this.form.id
                        res = await configGroupUpdate(groupData)
                    } else {
                        res = await configGroupAdd(groupData)
                    }

                    if (res && res.code === '0000') {
                        this.$message.success(this.isEdit ? '修改成功' : '添加成功')
                        this.dialogVisible = false
                        this.groupPage = 1
                        this.getConfigGroupList()
                    } else {
                        this.$message.error(res.message || (this.isEdit ? '修改失败' : '添加失败'))
                    }
                } catch (error) {
                    console.error('保存配置分组失败：', error)
                    this.$message.error(this.isEdit ? '修改失败' : '添加失败')
                }
            })
        },
        // 删除配置分组
        handleDeleteGroup(group) {
            this.$confirm(`确认删除配置分组「${group.name}」?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await configGroupDelete(group.id)
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功')
                        if (this.activeGroup === String(group.id)) {
                            this.activeGroup = ''
                            this.itemList = []
                            this.itemTotal = 0
                        }
                        this.groupPage = 1
                        this.getConfigGroupList()
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                } catch (error) {
                    console.error('删除配置分组失败：', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.product-config-container {
    display: flex;
    gap: 20px;
    min-height: 500px;
    flex-wrap: nowrap;
}

.config-group-list {
    width: 260px;
    min-width: 260px;
    flex-shrink: 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 左侧配置分组列表滚动容器：滚动到底部时加载下一页 */
.group-scroll {
    flex: 1;
    max-height: 480px;
    overflow-y: auto;
}

.load-more {
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
    color: #909399;
}

.list-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.group-menu {
    border-right: none;
}

.group-menu .el-menu-item {
    height: auto;
    line-height: 1.5;
    padding: 5px 20px !important;
}

.group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    width: 100%;
}

.group-name {
    font-size: 14px;
    color: #606266;
}

.group-actions {
    display: none;
    align-items: center;
    gap: 2px;
}

.group-item:hover .group-actions {
    display: flex;
}

.group-action-btn {
    padding: 0;
    color: #409eff;
}

.group-delete-btn {
    color: #f56c6c;
}

.item-table-wrapper {
    flex: 1;
    min-width: 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 20px;
    background-color: #fff;
    overflow-x: auto;
}

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
}

.table-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

.item-uploader {
    display: inline-block;
}

.item-uploader-image {
    width: 100px;
    height: 100px;
    border-radius: 6px;
    display: block;
}

.item-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
}
</style>